import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeepAliveComponent } from './components/keep-alive/keep-alive.component';
// NOTE: Refer to other comments with the same timestamp for context
// [Patterson, John - 2017.03.28.12.48]
//import {MegaMenuContent} from "./components/mega-menu/mega-menu-content.directive";
import { DismissibleAlertComponent } from './components/alerts/dismissible-alert/dismissible-alert.component';
import { GemsAlertComponent } from './components/alerts/gems-alert/gems-alert.component';


import { NavigationPanelComponent } from './components/navigation-panel/navigation-panel.component';

import { ModalDialogComponent } from './components/modal-dialog/modal-dialog.component';
import { GemsTopButtonComponent } from './components/top-button/gems-top-button/gems-top-button.component';
import { CustomPipesModule } from './pipes/custom-pipes.module';
import { SessionExpirationComponent } from './components/session-expiration/session-expiration.component';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { SessionExpirationDialogComponent } from './components/session-expiration/session-expiration-dialog/session-expiration-dialog.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { EventStepWrapperComponent } from '../shared/event-step-wrapper/event-step-wrapper.component';

import { ModalModule } from 'ngx-bootstrap/modal';
import { GemsWrapperComponent } from './components/gems-wrapper';
import { GemsSpinnerComponent } from './components/gems-spinner';
import { GemsBannerAlertComponent } from './components/gems-banner-alert';

@NgModule({
    imports: [
        CommonModule,
        CustomPipesModule,
        NgIdleKeepaliveModule.forRoot(),
        ModalModule.forRoot()
    ],
    providers: [],
    declarations: [
        KeepAliveComponent,
        //MegaMenuContent,
        DismissibleAlertComponent,
        GemsAlertComponent,
        NavigationPanelComponent,
        ModalDialogComponent,
        GemsTopButtonComponent,
        GemsTopButtonComponent,
        SessionExpirationComponent,
        SessionExpirationDialogComponent,
        ProgressBarComponent,
        EventStepWrapperComponent,
        GemsWrapperComponent,
        GemsSpinnerComponent,
        GemsBannerAlertComponent
    ],
    exports: [
        KeepAliveComponent,
        DismissibleAlertComponent,
        GemsAlertComponent,
        NavigationPanelComponent,
        ModalDialogComponent,
        GemsTopButtonComponent,
        SessionExpirationComponent,
        SessionExpirationDialogComponent,
        ProgressBarComponent,
        EventStepWrapperComponent,
        GemsWrapperComponent,
        GemsSpinnerComponent,
        GemsBannerAlertComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
